const chooseCityAndGrade = {
    state: {
        show: true
    },

    mutations: {
        chooseCityAndGrade(state, payload) {
            state.show = payload.show
        }
    },

    actions: {
        chooseCityAndGrade(context, payload) {
            setTimeout(function() {
                context.commit('chooseCityAndGrade', payload);
            }, 300);
        }
    }
}

export default chooseCityAndGrade



// WEBPACK FOOTER //
// ./src/stores/modules/chooseCityAndGrade.js